const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <p className="footer__brand">Ibrahem Hurani</p>
        <p className="footer__copy">© {year} — Designed &amp; built with care</p>
      </div>
    </footer>
  );
};

export default Footer;
